import { render, staticRenderFns } from "./ViewTotalGross.vue?vue&type=template&id=323c2210&scoped=true"
import script from "./ViewTotalGross.vue?vue&type=script&lang=js"
export * from "./ViewTotalGross.vue?vue&type=script&lang=js"
import style0 from "./ViewTotalGross.vue?vue&type=style&index=0&id=323c2210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c2210",
  null
  
)

export default component.exports